import { render } from "./CubeLoader.vue?vue&type=template&id=781a58b2&scoped=true"
import script from "./CubeLoader.vue?vue&type=script&lang=js"
export * from "./CubeLoader.vue?vue&type=script&lang=js"

import "./CubeLoader.vue?vue&type=style&index=0&id=781a58b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781a58b2"]])

export default __exports__